import { Plus, X } from "lucide-react"

import TypeGlyph from "./TypeGlyph"

// One removable order-grant chip: type glyph + title + remove-X. The remove
// dispatches DELETE /access/grants/:accessId (handled by the parent PersonCard).
export function GrantChip({ grant, onRemove }) {
  return (
    <div className="flex items-center gap-[9px] rounded-[10px] border border-border bg-accent py-[6px] pr-[7px] pl-[10px]">
      <span className="grid size-6 shrink-0 place-items-center rounded-[7px] border border-border bg-card">
        <TypeGlyph type={grant.type} className="size-[13px] text-muted-foreground" strokeWidth={1.9} />
      </span>
      <span className="max-w-[200px] truncate text-[12.5px] font-semibold text-foreground">{grant.title}</span>
      <button
        type="button"
        aria-label={`Remove access to ${grant.title}`}
        onClick={onRemove}
        className="grid size-5 place-items-center rounded-[6px] text-ink-3 hover:bg-[var(--red-soft)] hover:text-primary"
      >
        <X className="size-[13px]" strokeWidth={2.1} />
      </button>
    </div>
  )
}

// The dashed "Add a project" chip that trails the grant chips — opens the invite
// modal locked to this person's email (add-a-project mode).
export function AddProjectChip({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1.5 rounded-[10px] border border-dashed border-line-2 px-[12px] py-[7px] text-[12.5px] font-semibold text-muted-foreground transition-colors hover:border-foreground hover:bg-accent hover:text-foreground"
    >
      <Plus className="size-[14px]" strokeWidth={2} />
      Add a project
    </button>
  )
}
